const OVERLAY_DOM_PROPERTIES = {
    ID: '#cgp_overlay',
    ID_NAME: 'cgp_overlay',
    CLASS_NAME: 'cgp-overlay',
    CONTENT_CLASS_NAME: 'cgp-overlay-content'
};

const OVERLAY_COMPONENT_PROPERTIES = {
    ID: '#cgp_overlay',
    CLASS_NAME: 'OverlayComponentController'
};


const OVERLAY_CONTENT_PROPERTIES = {
    CLASS_NAME: 'cgp-overlay-content'
};

const PRIORITY_CLASS_MAP = {
    BASE: 'cgp-overlay-base',
    POP_UP: 'cgp-overlay-popup',
    OPEN_SESSION: 'cgp-overlay-open-session',
    FP: 'cgp-overlay-fp',
    OMG: 'cgp-overlay-omg',
    MESSAGE: 'cgp-overlay-message',
    TOUCH_ID: 'cgp-overlay-touch-id'
};

const TYPES_CLASS_MAP = {
    FLAT: 'cgp-overlay-flat',
    FULL_SCREEN: 'cgp-overlay-fullscreen'
};

const LIGHTBOX_BACKGROUND_COLOR_CLASS = 'cgp-theme-property-lightbox-background-color';

export {OVERLAY_DOM_PROPERTIES, OVERLAY_COMPONENT_PROPERTIES, OVERLAY_CONTENT_PROPERTIES, PRIORITY_CLASS_MAP, TYPES_CLASS_MAP, LIGHTBOX_BACKGROUND_COLOR_CLASS};